import { useI18N } from "@sundae/react-hooks";
import { useMemo } from "react";
import { MOCK_V3_RBERRY_POOL } from "../../../../../__mocks__/pools.v3";
import { Guides } from "../../../../components/JoyrideStepComponents";
import { SUNDAE_METADATA, readableAdaAssetId } from "../../../../constants/cardano.constants";
import { joyrideIds, joyrideSelectors } from "../../../../constants/joyride.constants";
import { paths } from "../../../../pages/routes";
import { ExchangeMode } from "../../../../stores";
import { EGuideChapter, IGuide } from "../../../../stores/ControlCenterContext";
import { getEnv } from "../../../../utils/network.utils";

export const useV3ComparisonGuideJoyride = (): IGuide => {
  const { t } = useI18N("joyride");

  return useMemo(
    () => ({
      rank: 3,
      description: t("v3.guides.comparison.description"),
      title: t("v3.guides.comparison.title"),
      chapter: EGuideChapter.V3,
      joyride: {
        id: joyrideIds.v3.comparison,
        steps: [
          {
            entryUrl: paths.exchange,
            title: t("v3.guides.comparison.steps.step1.title"),
            content: <Guides.V3.Comparison.Steps.Step1 />,
            placement: "center",
            target: "body",
            entrySearchParams: {
              mode: ExchangeMode.swap,
              given: readableAdaAssetId,
              taken:
                getEnv() === "preview"
                  ? MOCK_V3_RBERRY_POOL.assetB.assetId
                  : SUNDAE_METADATA.assetId,
            },
          },
          {
            entryUrl: paths.exchange,
            title: "Our Swap got even better",
            content: "With the new contracts, our swap is faster and cheaper than ever.",
            placement: "left",
            target: `[data-guide-selector="${joyrideSelectors.guides.exchange.exchangeWidget}"]`,
          },
          {
            entryUrl: paths.exchange,
            title: "Select your favorite v3 pool",
            content:
              "With our intuitive Pool Picker, you can easily find the pool you're looking for.",
            placement: "left",
            target: `[data-guide-selector="${joyrideSelectors.guides.exchange.liquidityPoolSelect}"]`,
            entrySearchParams: {
              mode: ExchangeMode.swap,
              given: readableAdaAssetId,
              taken:
                getEnv() === "preview"
                  ? MOCK_V3_RBERRY_POOL.assetB.assetId
                  : SUNDAE_METADATA.assetId,
            },
          },
          {
            entryUrl: paths.exchange,
            title: "Lower Fees for the first three months",
            content:
              "For the first three months, the Sundae DAO has voted to lower fees even further! From ₳1 to ₳0.5.",
            placement: "left",
            target: `[data-guide-selector="${joyrideSelectors.guides.exchange.scooperFee}"]`,
          },
          {
            entryUrl: paths.exchange,
            title: t("v3.guides.comparison.steps.step5.title"),
            content: <Guides.V3.Comparison.Steps.Step5 />,
            placement: "center",
            target: "body",
          },
          {
            entryUrl: paths.exchange,
            title: t("v3.guides.comparison.steps.step6.title"),
            content: t("v3.guides.comparison.steps.step6.description"),
            placement: "center",
            target: "body",
          },
          {
            entryUrl: paths.liquidity.root,
            title: t("v3.guides.comparison.steps.step7.title"),
            content: t("v3.guides.comparison.steps.step7.description"),
            placement: "bottom",
            target: `[data-guide-selector="${joyrideSelectors.guides.liquidity.filters}"]`,
          },
          {
            entryUrl: paths.liquidity.root,
            title: t("v3.guides.comparison.steps.step8.title"),
            content: <Guides.V3.Comparison.Steps.Step8 />,
            placement: "right",
            target: `[data-guide-selector="${joyrideSelectors.poolBadges.version.v3}"]`,
          },
          {
            entryUrl: paths.liquidity.root,
            title: t("v3.guides.comparison.steps.step9.title"),
            content: t("v3.guides.comparison.steps.step9.description"),
            placement: "center",
            target: "body",
          },
          {
            entryUrl: paths.liquidity.root,
            title: t("v3.guides.comparison.steps.step10.title"),
            content: t("v3.guides.comparison.steps.step10.description"),
            placement: "center",
            target: "body",
          },
          {
            entryUrl: paths.liquidity.root,
            title: t("v3.guides.comparison.steps.step11.title"),
            content: t("v3.guides.comparison.steps.step11.description"),
            placement: "center",
            target: "body",
          },
          {
            entryUrl: paths.liquidity.root,
            title: t("v3.guides.comparison.steps.step12.title"),
            content: t("v3.guides.comparison.steps.step12.description"),
            placement: "center",
            target: "body",
          },
          {
            entryUrl: paths.liquidity.root,
            title: t("v3.guides.comparison.steps.step13.title"),
            content: t("v3.guides.comparison.steps.step13.description"),
            placement: "center",
            target: "body",
          },
        ],
      },
    }),
    [t]
  );
};
